import axios from "axios";
import PasswordConfirmation from "@/js/Components/Modal/PasswordConfirmation.vue";
import {applyToStore, getFormLocalStorage, removeFromLocalStorage, storeToLocalStorage} from "@/js/helpers.js";
import XRefreshToken from "@/js/Components/XRefreshToken.vue";
import Unauthorized from "@/js/Components/Unauthorized.vue";

export default {
    install(app) {
        axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest';
        axios.defaults.baseURL = `/${__PREFIX__}`;
        axios.defaults.maxRedirects = 0;

        removeFromLocalStorage('x-refresh-token');
        removeFromLocalStorage('x-permission-hash');

        const store = app.config.globalProperties.$store;
        axios.interceptors.request.use((config) => {
            return config;
        });

        axios.interceptors.response.use((response) => {
            // todo: turn on http requests register
            return handleResponse(app, response)
        }, (error) => {
            if (!store.getters['app/online']) {
                return Promise.resolve({
                    status: 200,
                    statusText: 'Offline (mocked)',
                    data: { data: [] }, // or return cached data if you have any
                    config: error.config,
                    headers: {},
                    offline: true, // custom flag
                });
            }
            return handleError(app, error);
        });
    }
}

function isHTML(content) {
    const doc = new DOMParser().parseFromString(content, 'text/html');
    return [...doc.body.childNodes].some(node => node.nodeType === 1);
}

function handleResponse(app, response) {
    const requestUrl = parseUrl(response.config.url);
    const responseUrl = parseUrl(response.request.responseURL);

    if (!response.config?.ignoreRefreshToken) {
        checkIfNeedToRefresh(app, response);
    }

    if (requestUrl !== responseUrl) {
        app.config.globalProperties.$loader.show();
        const message = !isHTML(response.data) ? response.data : null;
        location.href = `${response.request.responseURL}${message ? `?message=${message}` : ''}`;
        console.error(requestUrl, responseUrl, requestUrl === responseUrl);
        throw ({ name: 'Error', code: 302});
    }

    let data = response.data?.data || response.data;
    if (!data) return;

    if (typeof data === 'string') {
        try {
            data = JSON.parse(data);
        } catch (e) {
            //console.error('[HTTP response] data is not JSON type!', response);
            // return;
        }
    }

    if (response.data?.notifications) {
        const notifications = response.data.notifications;
        (Array.isArray(notifications) ? notifications : Object.values(notifications)).forEach(notification => {
            app.config.globalProperties.$noty(notification);

            // todo: find better way to handle
            if (notification.isEvent) {
                app.config.globalProperties.$store.commit('event/prependToList', notification.data);
                app.config.globalProperties.$store.commit('event/prependToSidebarList', notification.data.id);
            }
        });
    }

    if (response.data?.popups) {
        const popups = response.data.popups;
        (Array.isArray(popups) ? popups : Object.values(popups)).forEach(popup => {
            app.config.globalProperties.$popup(Object.assign({
                id: popup.id
            }, popup.data));
        });
    }

    if (data instanceof Object) {
        if (data?.notify) {
            app.config.globalProperties.$noty(data.notify);
        }


        if (data?.events) {
            data.events.forEach(event => {
                app.config.globalProperties.$emitter.emit(event);
            });
        }


        const store = app.config.globalProperties.$store;
        applyToStore(data, store);

        if(data?.redirect) {
            app.config.globalProperties.$router.push(data.redirect);
        }
    }

    return response;
}

async function handleError(app, error) {
    const reject = Promise.reject(error);

    if (error?.config?.image) {
        return reject;
    }

    if (error?.response?.status === 400) {
        let data = typeof error.response?.data === 'string' ? JSON.parse(error.response.data) : {};
        app.config.globalProperties.$modal(
            PasswordConfirmation,
            {
                id: 'password-confirmation',
                message: data?.message,
                response: error.response,
            }
        );
        return reject;
    }

    if (error?.response?.status === 401) {
        if (error.response.data?.suspended) {
            window.location.href = '/suspended';
            app.config.globalProperties.$loader.show();
            return reject;
        }

        if (error?.config?.headers?.Authentication !== '1') {
            app.config.globalProperties.$modal(
                Unauthorized
            , { id : 'Unauthorized' });
        }
        return reject;
    }

    if ([403, 404].indexOf(error?.response?.status) !== -1 && !error.config?.ignoreErrorNotification) {
        if (error?.config && error.config.headers?.Authentication !== '1') {
            app.config.globalProperties.$error(error.response.statusText, error.response.data?.message);
        }
        return reject;
    }

    if (!error?.response?.data?.notify) return reject;
    app.config.globalProperties.$noty(error?.response?.data?.notify);
    return reject;
}

function parseUrl(url) {
    return url.replace(location.origin, '')
        .replace(axios.defaults. baseURL, '')
        .replace(/^[\/]/, '')
        .replace(/[?].*/, '')
}


function checkIfNeedToRefresh(app, response) {
    if (typeof response.headers['x-refresh-token'] === 'undefined') return;

    const refreshToken = response.headers['x-refresh-token'] || null;
    const permissionHash = response.headers['x-permission-hash'] || null;
    const currentToken = getFormLocalStorage('x-refresh-token', null);
    const currentHash = getFormLocalStorage('x-permission-hash', null);
    let permissionHashChanged = false;
    let refreshTokenChanged = false;

    if (currentHash !== permissionHash) {
        permissionHashChanged = !!currentHash;
        storeToLocalStorage('x-permission-hash', permissionHash);
    }

    if (currentToken !== refreshToken) {
        refreshTokenChanged = !!currentToken;
        storeToLocalStorage('x-refresh-token', refreshToken);
    }

    if (!permissionHashChanged && !refreshTokenChanged) return;

    app.config.globalProperties.$modal(XRefreshToken, {
        id: 'x-refresh-token'
    })
}

export function makeLink(url)
{
    return `/${__PREFIX__}${url.match(/^(\/)/) ? url : '/' + url}`;
}